import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { SOURCE_STRINGS } from '../../../constants'
import NewsFeedItemContainer from './StyledNewsFeedItemContainer'
import NewsFeedLink from './StyledNewsFeedLink'
import NewsFeedImage from './StyledNewsFeedImage'
import NewsFeedContentWrapper from './StyledNewsFeedContentWrapper'
import NewsFeedTitle from './StyledNewsFeedTitle'
import NewsFeedInfo from './StyledNewsFeedInfo'
import NewsFeedAdvertSign from './StyledNewsFeedAdvertSign'

class NewsFeedItem extends Component {
  constructor (props) {
    super(props)
    this.handleAnchorClick = this.handleAnchorClick.bind(this)
  }

  isGoogleAnalyticsSet () {
    return typeof this.props.googleAnalytics !== 'undefined'
  }

  componentDidMount () {
    const {
      box: {
        gaCategory: category,
        guid: id,
        title: name
      },
      position,
      googleAnalytics
    } = this.props

    const impressionFieldObject = {
      id,
      name,
      category,
      list: 'Newsfeed',
      position
    }

    if (this.isGoogleAnalyticsSet()) {
      googleAnalytics.addImpression(impressionFieldObject)
    }
  }

  handleAnchorClick (event, location) {
    event.preventDefault()

    const {
      box: {
        guid: id,
        title: name,
        gaCategory: category
      },
      googleAnalytics
    } = this.props

    const purchaseFieldObject = {
      id,
      name,
      category
    }

    if (this.isGoogleAnalyticsSet()) {
      googleAnalytics.handlePurchaseEvent(purchaseFieldObject).then(() => {
        document.location.href = location
      }).catch(() => {
        document.location.href = location
      })
    } else {
      document.location.href = location
    }
  }

  render () {
    const {
      ad,
      box: {
        category,
        guid,
        image,
        link,
        source,
        title
      }
    } = this.props

    return (
      <NewsFeedItemContainer key={guid}>
        <NewsFeedLink
          href={link}
          onClick={event => {
            this.handleAnchorClick(event, link)
          }}
        >
          <NewsFeedImage src={image} alt={title}/>
          <NewsFeedContentWrapper>
            <NewsFeedTitle>
              {title}
            </NewsFeedTitle>
            {
              !ad &&
              <NewsFeedInfo source={source}>
                {SOURCE_STRINGS[source]}
                {
                  category &&
                  ` | ${category}`
                }
              </NewsFeedInfo>
            }
            {
              ad &&
              <NewsFeedAdvertSign/>
            }
          </NewsFeedContentWrapper>
        </NewsFeedLink>
      </NewsFeedItemContainer>
    )
  }
}

NewsFeedItem.propTypes = {
  ad: PropTypes.bool,
  box: PropTypes.object.isRequired
}

NewsFeedItem.defaultProps = {
  ad: false
}

export default NewsFeedItem
